<template>
    <KFieldWrapper>
        <KLabel :class="'k-form-label'" :editor-id="id" :editor-valid="valid" :disabled="disabled" :optional="optional">
            {{ label }}
            <span v-if="props.required" class="formRequired">*</span>
        </KLabel>
        <div class="k-form-field-wrap" v-show="!props.disabled">
            <KInput :style="{ width: '100%' }" ref="theInput" :id="id" :valid="showValid" :disabled="disabled"
                :default-value="value" :placeholder="placeholder" :maxlength="maxLength" @input="handleChange"
                @blur="handleBlur" @focus="handleFocus" />
            <KError v-if="showValidationMessage">
                {{ validationMessage }}
            </KError>
            <KHint v-else :direction="'end'"> {{ value.length }} / {{ props.maxLength }} </KHint>
        </div>
        <div class="k-form-field-wrap" v-show="props.disabled">
            {{ valueDisplay }}
        </div>
    </KFieldWrapper>
</template>

<script setup>
import { FieldWrapper as KFieldWrapper } from "@progress/kendo-vue-form";
import { Error as KError, Hint as KHint, Label as KLabel } from "@progress/kendo-vue-labels";
import { Input as KInput } from "@progress/kendo-vue-inputs";
import { computed, defineProps, defineEmits, ref, onMounted } from 'vue';

const emit = defineEmits(['change', 'blur', 'focus']);

// Props
const props = defineProps({
    optional: Boolean,
    disabled: Boolean,
    placeholder: String,
    touched: Boolean,
    focus: Boolean,
    label: String,
    required: Boolean,
    validationMessage: String,
    hint: String,
    id: String,
    valid: Boolean,
    maxLength: Number,
    value: {
        type: String,
        default: ''
    }
});
const theInput = ref(null);
const valueDisplay = ref('');

onMounted(() => {
    // Get the value to display when disabled.
    valueDisplay.value = props.value;
    if (props.focus) {
        theInput.value.focus();
    }
})

// Computed
const showValid = computed(() => {
    if (!props.touched) { return true; }
    return props.valid;
})

const showValidationMessage = computed(() => {
    return props.touched && props.validationMessage;
})

const showHint = computed(() => {
    return !showValidationMessage.value && props.hint;
})

const hintId = computed(() => {
    return showHint.value ? '${props.id}_hint' : "";
})

const errorId = computed(() => {
    return showValidationMessage.value ? '${props.id}_error' : "";
})


// Methods
const handleChange = function (e) {
    emit('change', e);
}

const handleBlur = function (e) {
    emit('blur', e);
}

const handleFocus = function (e) {
    emit('focus', e);
}
</script>
